module.exports = __webpack_public_path__ + "img/bio-katrina-hood.8108de74.png";